






























































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName, matchedIndexIdInArray } from '../../core/utils';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper, AuthStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
// import VariableClassification from '../components/VariableClassification.vue';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { NormsServices } from '../api/NormsServices';
import { PageTitle } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import ModalVariableReport from '../components/ModalVariableReport.vue';
import { formatList } from '../../core/utils/';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { VariableReport, VariableReportList } from '../models/VariableReport';

@Component({
    components: {
        PageTitle,
        // VariableClassification,
        ModalVariableReport,
        DeleteConfirmation,
        SimpleTable,
        Button,
        Input
    }
})
export default class NormasVariableReport extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper
) {
    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [true];
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    deleteMsg: string[] = ['Las variables classifications asociadas al mismo van a perder la asociacion'];
    variableReportToDelete: number = -1;
    variableReportToEdit: VariableReportList | null = null;
    deleteConfirmationTitle: string = 'Eliminar Variable classification';
    deleteConfirmationMessage: string =
        '¿Está seguro que desea eliminar esta Variable classification? Ésta acción no se podrá deshacer.';

    pendingRequest: boolean = false;
    search: string = '';

    headers: Array<object> = [
        {
            text: 'ID',
            align: 'center',
            value: 'id',
            width: '80px'
        },
        {
            text: 'Descripción pública',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Descripción privada',
            align: 'left',
            value: 'private_description'
        },
        {
            text: 'Clasificaciones',
            align: 'left',
            value: 'classifications',
            tooltip: '',
            formatter: this.formatClassifications
        },
        {
            text: 'Acciones',
            align: 'left',
            value: 'actions',
            sortable: false,
            width: '80px'
        }
    ];
    itemsTable: Array<VariableReportList> = [];
    visibleModalVariableReport: boolean = false;

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;

            NormsServices.deleteVariableReport(this.variableReportToDelete)
                .then(response => {
                    this.$_successDeleteRecipients(response['data']['message']);
                    this.removeVariableReportFromList(this.variableReportToDelete);
                })
                .catch(error => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        this.$_errorPatchRecipients(error.response.data.message);
                    } else {
                        this.$_errorPatchRecipients('No se pudo eliminar la Variable Report');
                    }
                });
        } else {
            this.confirmationDelete = false;
        }
    }

    removeVariableReportFromList(id: number) {
        let index = matchedIndexIdInArray(this.itemsTable, id);
        if (index !== -1) {
            this.itemsTable.splice(index, 1);
        }
        this.variableReportToDelete = -1;
    }

    deleteVariableReport(item: VariableReportList) {
        this.variableReportToDelete = item['id'];
        this.deleteModalTitle = 'Eliminar Variable Report';
        this.deleteBody = '¿Está seguro que desea eliminar la Variable Report: ' + '<b>"' + item.description + '"</b>?';
        this.confirmationDelete = true;
    }

    addNewVariableReportToList(variableReport: VariableReport) {
        let varReport: VariableReportList = {
            ...variableReport,
            classifications: []
        };
        this.itemsTable.push(varReport);
    }

    editVariableReport(variableReport: VariableReportList) {
        this.$set(variableReport, 'loading', true);
        NormsServices.getVariableReport(variableReport.id)
            .then(res => {
                this.variableReportToEdit = res;
                this.visibilityModalVariableReport(true);
            })
            .catch(err => {
                this.$set(variableReport, 'loading', false);
            });
    }

    visibilityModalVariableReport(value) {
        this.visibleModalVariableReport = value;
    }

    addVariableReport() {
        this.variableReportToEdit = null;
        this.visibilityModalVariableReport(true);
    }

    updateSearchValue(value) {
        this.search = value;
    }
    backToNormas() {
        this.$router.push(NAME_ROUTES.NORMAS.path);
    }

    mounted() {
        this.getVariableReportList();
    }

    loadingTable(value) {
        this.pendingRequest = value;
    }

    getVariableReportList() {
        this.loadingTable(true);

        NormsServices.getVariableReportList()
            .then((res: Array<VariableReportList>) => {
                this.itemsTable = res;
                this.loadingTable(false);
            })
            .catch(res => {
                this.loadingTable(false);
            });
    }

    formatClassifications(value) {
        return formatList(value, 'description');
    }
}
